"use strict";
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceProvider = exports.BuyingProgram = exports.SalesChannel = exports.MarketSegment = exports.CustomerSegment = exports.Term = exports.Commitment = exports.OfferType = void 0;
var OfferType;

(function (OfferType) {
  OfferType["BASE"] = "BASE";
  OfferType["TRIAL"] = "TRIAL";
  OfferType["PROMOTION"] = "PROMOTION";
})(OfferType = exports.OfferType || (exports.OfferType = {}));

var Commitment;

(function (Commitment) {
  Commitment["MONTH"] = "MONTH";
  Commitment["YEAR"] = "YEAR";
  Commitment["TWO_YEARS"] = "TWO_YEARS";
  Commitment["THREE_YEARS"] = "THREE_YEARS";
  Commitment["PERPETUAL"] = "PERPETUAL";
})(Commitment = exports.Commitment || (exports.Commitment = {}));

var Term;

(function (Term) {
  Term["ANNUAL"] = "ANNUAL";
  Term["MONTHLY"] = "MONTHLY";
  Term["TWO_YEARS"] = "TWO_YEARS";
  Term["THREE_YEARS"] = "THREE_YEARS";
})(Term = exports.Term || (exports.Term = {}));

var CustomerSegment;

(function (CustomerSegment) {
  CustomerSegment["INDIVIDUAL"] = "INDIVIDUAL";
  CustomerSegment["TEAM"] = "TEAM";
  CustomerSegment["ENTERPRISE"] = "ENTERPRISE";
})(CustomerSegment = exports.CustomerSegment || (exports.CustomerSegment = {}));

var MarketSegment;

(function (MarketSegment) {
  MarketSegment["COM"] = "COM";
  MarketSegment["EDU"] = "EDU";
  MarketSegment["GOV"] = "GOV";
})(MarketSegment = exports.MarketSegment || (exports.MarketSegment = {}));

var SalesChannel;

(function (SalesChannel) {
  SalesChannel["DIRECT"] = "DIRECT";
  SalesChannel["INDIRECT"] = "INDIRECT";
})(SalesChannel = exports.SalesChannel || (exports.SalesChannel = {}));

var BuyingProgram;

(function (BuyingProgram) {
  BuyingProgram["ENTERPRISE_PRODUCT"] = "ENTERPRISE_PRODUCT";
  BuyingProgram["ETLA"] = "ETLA";
  BuyingProgram["RETAIL"] = "RETAIL";
  BuyingProgram["VIP"] = "VIP";
  BuyingProgram["VIPMP"] = "VIPMP";
  BuyingProgram["FREE"] = "FREE";
})(BuyingProgram = exports.BuyingProgram || (exports.BuyingProgram = {}));

var ServiceProvider;

(function (ServiceProvider) {
  ServiceProvider["FIG_ID"] = "FIG_ID";
  ServiceProvider["MATERIAL"] = "MATERIAL";
  ServiceProvider["MERCHANDISING"] = "MERCHANDISING";
  ServiceProvider["PRICING"] = "PRICING";
  ServiceProvider["PRODUCT_ARRANGEMENT"] = "PRODUCT_ARRANGEMENT";
  ServiceProvider["PAYMENT_INSTRUMENTS"] = "PAYMENT_INSTRUMENTS";
})(ServiceProvider = exports.ServiceProvider || (exports.ServiceProvider = {}));